import { toastError } from "../pageUtil/toast";
import { PresignedPost } from "../types/PresignedPost";

// Path: ./src/utils/storeUploadImage/index.ts
type SignedRequestResponse = {
  signedUrl: PresignedPost;
  filename: string;
  fileKey: string;
  publicUrl: string;
};

async function storeUploadImageFile(
  file: File,
  jsonResult: SignedRequestResponse
): Promise<{ alt: string; src: string; fileName: string } | null> {
  const formParams = jsonResult.signedUrl;
  const formData = new FormData();
  Object.keys(formParams.fields).forEach((key) => {
    formData.append(key, formParams.fields[key]);
  });
  formData.append("file", file);

  const response = await fetch(formParams.url, {
    method: "POST",
    body: formData,
  });
  if (response.status === 204) {
    console.log("File uploaded successfully, no content returned");
  } else if (response.status === 400) {
    toastError(
      `Unable to upload ${jsonResult.filename}: Image size exceeds the 10MB limit.`
    );
    return null;
  } else if (!response.ok) {
    toastError(`Unable to upload ${jsonResult.filename} this.`);
    console.error(`${response.status}: ${response.statusText}`);
    return null;
  }

  return {
    alt: jsonResult.filename.split(".")[0],
    src: jsonResult?.publicUrl,
    fileName: jsonResult.filename.split(".")[0],
  };
}

async function getStoreUploadSignedRequest(
  file: File,
  small: boolean
): Promise<SignedRequestResponse> {
  const unique13digitNumber = Math.floor(
    1000000000000 + Date.now() + Math.random() * 9000000000000
  );

  const n = file.name.lastIndexOf(".");
  const fileName = encodeURIComponent(
    `${file.name.substring(0, n)}_${unique13digitNumber}${file.name.substring(
      n
    )}`
  );

  const prefix = small ? "small-" : "";
  const url = `${process.env.REACT_APP_GOFLYER_API_END_POINT}/s3/getPresignedPostUrl?objectName=${prefix}${fileName}&contentType=${file.type}&path=storeUploadedImage`;

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error(`${response.status}: ${response.statusText}`);
  }

  return response.json();
}

async function storeUploadImageTos3(
  file: File,
  small: boolean
): Promise<{ alt: string; src: string; fileName: string } | null> {
  try {
    const json = await getStoreUploadSignedRequest(file, small);
    return await storeUploadImageFile(file, json);
  } catch (err) {
    console.error(err);
    return null;
  }
}

export {
  getStoreUploadSignedRequest,
  storeUploadImageTos3,
  storeUploadImageFile,
};
